import { SECTION_USERS } from "common/routes/sections/main.sections";

export const USERS_URL = `/${SECTION_USERS.path}`;

export const USER_FORM = {
  path: "form/",
  params: ":userId?/",
  backTo: USERS_URL,
  subtitle: "User Form",
  title: "Users View",
  withStepper: false,
  withDate: true,
};
